( function () {
	function stampCf7Forms() {
		document
			.querySelectorAll( '.wpcf7-form input[name^="nexo_cf7_rendered_at_"]' )
			.forEach( function ( input ) {
				input.value = String( Math.floor( Date.now() / 1000 ) );
			} );
	}

	function initScienceVideos() {
		function hydrateEndScreenBrand( player ) {
			var brandSlot = player.querySelector( '[data-science-video-end-logo]' );
			var brandImage = document.querySelector( '.navbar-brand img, .custom-logo-link img' );
			var brandText = document.querySelector( '.navbar-brand' );
			var clone;

			if ( ! brandSlot || brandSlot.dataset.ready === 'true' ) {
				return;
			}

			brandSlot.innerHTML = '';
			brandSlot.classList.remove( 'science-page__video-end-brand--text' );

			if ( brandImage ) {
				clone = brandImage.cloneNode( true );
				clone.removeAttribute( 'srcset' );
				clone.removeAttribute( 'sizes' );
				clone.loading = 'eager';
				clone.decoding = 'async';
				brandSlot.appendChild( clone );
			} else if ( brandText ) {
				brandSlot.textContent = brandText.textContent.replace( /\s+/g, ' ' ).trim();
				brandSlot.classList.add( 'science-page__video-end-brand--text' );
			}

			brandSlot.dataset.ready = 'true';
		}

		function showEndScreen( player ) {
			var endScreen = player.querySelector( '[data-science-video-end]' );
			var video = player.querySelector( '.science-page__video-media' );

			player.classList.add( 'is-ended' );

			if ( video ) {
				video.setAttribute( 'tabindex', '-1' );
			}

			if ( endScreen ) {
				endScreen.removeAttribute( 'hidden' );
				endScreen.setAttribute( 'aria-hidden', 'false' );
			}
		}

		function hideEndScreen( player ) {
			var endScreen = player.querySelector( '[data-science-video-end]' );
			var video = player.querySelector( '.science-page__video-media' );

			player.classList.remove( 'is-ended' );

			if ( video ) {
				video.removeAttribute( 'tabindex' );
			}

			if ( endScreen ) {
				endScreen.setAttribute( 'hidden', '' );
				endScreen.setAttribute( 'aria-hidden', 'true' );
			}
		}

		function playEmbeddedVideo( player ) {
			var video = player.querySelector( '.science-page__video-media' );

			if ( ! video ) {
				return;
			}

			player.classList.add( 'is-loaded' );
			hideEndScreen( player );
			hydrateEndScreenBrand( player );

			try {
				video.currentTime = 0;
			} catch ( error ) {
				// Some browsers may block currentTime until metadata is ready.
			}

			video.play().catch( function () {
				player.classList.remove( 'is-loaded' );
			} );
		}

		document.querySelectorAll( '[data-science-video-player]' ).forEach( function ( player ) {
			var button = player.querySelector( '[data-science-video-play]' );
			var replayButton = player.querySelector( '[data-science-video-replay]' );
			var video = player.querySelector( '.science-page__video-media' );

			if ( ! button || ! video || player.dataset.scienceVideoBound === 'true' ) {
				return;
			}

			player.dataset.scienceVideoBound = 'true';
			hydrateEndScreenBrand( player );

			button.addEventListener( 'click', function () {
				playEmbeddedVideo( player );
			} );

			if ( replayButton ) {
				replayButton.addEventListener( 'click', function () {
					playEmbeddedVideo( player );
				} );
			}

			video.addEventListener( 'play', function () {
				player.classList.add( 'is-loaded' );
				hideEndScreen( player );
			} );

			video.addEventListener( 'ended', function () {
				showEndScreen( player );
			} );
		} );
	}

	function initContactMaps() {
		if ( typeof window.L === 'undefined' ) {
			return;
		}

		function syncContactMapBlend( map ) {
			var mapPane = map && map._mapPane;
			var size = map && map.getSize ? map.getSize() : null;
			var offset = mapPane && window.L.DomUtil ? window.L.DomUtil.getPosition( mapPane ) : null;

			if ( ! mapPane || ! size ) {
				return;
			}

			mapPane.style.setProperty( '--contact-map-width', size.x + 'px' );
			mapPane.style.setProperty( '--contact-map-height', size.y + 'px' );
			mapPane.style.setProperty( '--contact-map-offset-x', ( offset ? offset.x : 0 ) + 'px' );
			mapPane.style.setProperty( '--contact-map-offset-y', ( offset ? offset.y : 0 ) + 'px' );
		}

		document.querySelectorAll( '[data-contact-map]' ).forEach( function ( mapElement ) {
			if ( mapElement._leafletMap ) {
				window.requestAnimationFrame( function () {
					mapElement._leafletMap.invalidateSize();
					syncContactMapBlend( mapElement._leafletMap );
				} );
				return;
			}

			var lat = Number.parseFloat( mapElement.dataset.lat || '42.3637' );
			var lng = Number.parseFloat( mapElement.dataset.lng || '-71.1606' );
			var zoom = Number.parseFloat( mapElement.dataset.zoom || '17.8' );
			var coords = [ lat, lng ];

			mapElement._leafletMap = window.L.map( mapElement, {
				zoomControl: false,
				attributionControl: false,
				scrollWheelZoom: false,
				dragging: true,
				tap: false
			} ).setView( coords, zoom );

			window.L.tileLayer(
				'https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png',
				{
					subdomains: 'abcd',
					maxZoom: 20,
					opacity: 1
				}
			).addTo( mapElement._leafletMap );

			window.L.marker( coords, {
				icon: window.L.divIcon( {
					className: 'contact-page__map-marker',
					html:
						'<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true"><path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"/></svg>',
					iconSize: [ 34, 34 ],
					iconAnchor: [ 17, 34 ]
				} )
			} ).addTo( mapElement._leafletMap );

			mapElement._leafletMap.on( 'move zoom resize viewreset zoomend moveend', function () {
				syncContactMapBlend( mapElement._leafletMap );
			} );

			window.requestAnimationFrame( function () {
				mapElement._leafletMap.invalidateSize();
				syncContactMapBlend( mapElement._leafletMap );
			} );
		} );
	}

	function initScrollReveal() {
		var initialViewportRevealDelay = 180;
		var wrapperRevealSelectors = [
			'#main-nav .nexo-site-shell',
			'.pipeline-page__head',
			'.pipeline-page__row',
			'.team-page__intro',
			'.team-page__leader-card',
			'.team-page__quote',
			'.team-page__compact-card',
			'.science-page__video-shell',
			'.site-footer__inner'
		].join( ',' );
		var revealGroupSelectors = [
			'#main-nav .nexo-site-shell',
			'.pipeline-page__group',
			'.pipeline-page__content',
			'.team-page__leadership-grid',
			'.team-page__compact-grid',
			'.team-page__hero',
			'.team-page__section',
			'.science-page__video-shell',
			'.site-footer__inner',
			'.home-targets__overlay',
			'.home-targets__mobile',
			'.home-approach__timeline',
			'.site-footer',
			'.navbar-nav',
			'main section',
			'.entry-content'
		].join( ',' );
		var revealSelectors = [
			'.navbar-brand',
			'.navbar-nav > .nav-item > .nav-link',
			'.site-footer .footer-brand',
			'.site-footer .footer-nav a',
			'.site-footer .footer-nav__copy',
			'.site-footer .footer-follow',
			'.site-footer .footer-social',
			'#main-nav .nexo-site-shell',
			'main h1',
			'main h2',
			'main h3',
			'main h4',
			'main h5',
			'main h6',
			'main p',
			'main li',
			'main blockquote',
			'main figcaption',
			'main figure',
			'main img',
			'main picture',
			'main video',
			'main iframe',
			'main table',
			'main label',
			'main small',
			'main button',
			'main .btn',
			'main .home-targets__mobile-line',
			'main .home-targets__mobile-center',
			'main .home-targets__marker',
			'main .home-targets__connector',
			'main .home-targets__arrow',
			'main .home-approach__connector',
			'main [data-science-video-player]',
			'main .science-page__video-shell',
			'main .contact-page__map-shell',
			'main .contact-page__map',
			'main .pipeline-page__head',
			'main .pipeline-page__row',
			'main .team-page__intro',
			'main .team-page__leader-card',
			'main .team-page__quote',
			'main .team-page__compact-card',
			'main .wp-block-image',
			'main .wp-block-cover',
			'main .wp-block-gallery'
		].join( ',' );
		var reducedMotionQuery = window.matchMedia( '(prefers-reduced-motion: reduce)' );
		var revealTargets = Array.from( document.querySelectorAll( revealSelectors ) );
		var groupIdSequence = 0;

		function hasContent( element ) {
			return Boolean( ( element.textContent || '' ).replace( /\s+/g, ' ' ).trim().length );
		}

		function isMediaTarget( element ) {
			return element.matches(
				[
					'.navbar-brand',
					'.footer-brand',
					'.footer-social',
					'figure',
					'img',
					'picture',
					'video',
					'iframe',
					'[data-science-video-player]',
					'.contact-page__map-shell',
					'.contact-page__map',
					'.wp-block-image',
					'.wp-block-cover',
					'.wp-block-gallery'
				].join( ',' )
			);
		}

		function isConnectorTarget( element ) {
			return element.matches(
				[
					'.home-targets__mobile-line',
					'.home-targets__mobile-center',
					'.home-targets__marker',
					'.home-targets__connector',
					'.home-targets__arrow',
					'.home-approach__connector'
				].join( ',' )
			);
		}

		function isWrapperRevealTarget( element ) {
			return element.matches( wrapperRevealSelectors );
		}

		function getRevealGroup( element ) {
			return (
				element.closest( revealGroupSelectors ) ||
				element.closest( 'main, footer, nav' ) ||
				document.body
			);
		}

		function assignRevealDelays( elements ) {
			var rowAnchorTop = null;
			var rowIndex = -1;
			var columnIndex = 0;
			var rowThreshold = 40;
			var orderedElements = elements
				.map( function ( element ) {
					var rect = element.getBoundingClientRect();

					return {
						element: element,
						top: rect.top + window.pageYOffset,
						left: rect.left + window.pageXOffset,
						right: rect.right + window.pageXOffset
					};
				} )
				.sort( function ( first, second ) {
					if ( Math.abs( first.top - second.top ) > rowThreshold ) {
						return first.top - second.top;
					}

					if ( Math.abs( first.right - second.right ) > 1 ) {
						return second.right - first.right;
					}

					return second.left - first.left;
				} );

			orderedElements.forEach( function ( item ) {
				if ( null === rowAnchorTop || Math.abs( item.top - rowAnchorTop ) > rowThreshold ) {
					rowAnchorTop = item.top;
					rowIndex += 1;
					columnIndex = 0;
				}

				item.element.style.setProperty(
					'--nexo-reveal-delay',
					String( Math.min( ( rowIndex * 110 ) + ( columnIndex * 72 ), 560 ) ) + 'ms'
				);

				columnIndex += 1;
			} );
		}

		function shouldSkipElement( element ) {
			if (
				! element ||
				element.dataset.nexoRevealSkip === 'true' ||
				element.closest( '[data-nexo-reveal-skip="true"]' )
			) {
				return true;
			}

			if (
				element.closest(
					[
						'.screen-reader-text',
						'.screen-reader-response',
						'.wpcf7-spinner',
						'.leaflet-control-container',
						'.leaflet-pane',
						'.skip-link'
					].join( ',' )
				)
			) {
				return true;
			}

			if ( ! element.getClientRects().length ) {
				return true;
			}

			if ( ! isWrapperRevealTarget( element ) && element.closest( wrapperRevealSelectors ) ) {
				return true;
			}

			if ( element.matches( 'img' ) ) {
				if ( ! element.getAttribute( 'src' ) && ! element.getAttribute( 'srcset' ) ) {
					return true;
				}

				if (
					element.closest(
						[
							'figure',
							'picture',
							'[data-science-video-player]',
							'.contact-page__map-shell',
							'.contact-page__map',
							'.wp-block-image',
							'.wp-block-cover',
							'.wp-block-gallery'
						].join( ',' )
					)
				) {
					return true;
				}
			}

			if ( element.matches( 'iframe, video' ) && element.closest( '[data-science-video-player]' ) ) {
				return true;
			}

			if (
				element.matches(
					[
						'main h1',
						'main h2',
						'main h3',
						'main h4',
						'main h5',
						'main h6',
						'main p',
						'main li',
						'main blockquote',
						'main figcaption',
						'main label',
						'main small',
						'main button',
						'main .btn',
						'.navbar-nav > .nav-item > .nav-link',
						'.site-footer .footer-nav a',
						'.site-footer .footer-nav__copy',
						'.site-footer .footer-follow'
					].join( ',' )
				) &&
				! hasContent( element )
			) {
				return true;
			}

			return false;
		}

		function revealElement( element, observer ) {
			element.classList.add( 'is-revealed' );

			if ( observer ) {
				observer.unobserve( element );
			}
		}

		function getInitiallyVisibleElements( elements ) {
			var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

			return elements.filter( function ( element ) {
				var rect = element.getBoundingClientRect();

				return rect.bottom > 0 && rect.top < viewportHeight * 0.94;
			} );
		}

		function maybeRevealElementsAtPageEnd() {
			var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
			var viewportBottom = scrollTop + window.innerHeight;
			var documentHeight = Math.max(
				document.body ? document.body.scrollHeight : 0,
				document.documentElement.scrollHeight
			);

			if ( viewportBottom < documentHeight - 96 ) {
				return;
			}

			document.querySelectorAll( '[data-nexo-reveal]:not(.is-revealed)' ).forEach( function ( element ) {
				revealElement( element );
			} );
		}

		if ( ! revealTargets.length ) {
			return;
		}

		var filteredTargets = revealTargets.filter( function ( element ) {
			if ( shouldSkipElement( element ) ) {
				return false;
			}

			if ( element.dataset.nexoRevealBound !== 'true' ) {
				element.dataset.nexoReveal = '';
				element.dataset.nexoRevealBound = 'true';

				if ( isConnectorTarget( element ) ) {
					element.dataset.nexoRevealType = 'connector';
				} else if ( isMediaTarget( element ) ) {
					element.dataset.nexoRevealType = 'media';
				}
			}

			return true;
		} );

		var groupedTargets = new Map();

		filteredTargets.forEach( function ( element ) {
			var group = getRevealGroup( element );
			var groupId = group.dataset.nexoRevealGroupId;

			if ( ! groupId ) {
				groupIdSequence += 1;
				groupId = 'nexo-reveal-group-' + String( groupIdSequence );
				group.dataset.nexoRevealGroupId = groupId;
			}

			if ( ! groupedTargets.has( groupId ) ) {
				groupedTargets.set( groupId, [] );
			}

			groupedTargets.get( groupId ).push( element );
		} );

		groupedTargets.forEach( function ( targets ) {
			assignRevealDelays( targets );
		} );

		document.documentElement.classList.remove( 'nexo-prereveal' );
		document.documentElement.classList.add( 'nexo-reveal-enabled' );

		if ( reducedMotionQuery.matches || typeof window.IntersectionObserver === 'undefined' ) {
			document.querySelectorAll( '[data-nexo-reveal]' ).forEach( function ( element ) {
				revealElement( element );
			} );
			return;
		}

		var observer = new window.IntersectionObserver(
			function ( entries ) {
				entries.forEach( function ( entry ) {
					if ( entry.isIntersecting ) {
						revealElement( entry.target, observer );
					}
				} );
			},
			{
				threshold: 0.08,
				rootMargin: '0px 0px -4% 0px'
			}
		);
		var unrevealedElements = Array.from( document.querySelectorAll( '[data-nexo-reveal]:not(.is-revealed)' ) );
		var initiallyVisibleElements = getInitiallyVisibleElements( unrevealedElements );
		var initiallyVisibleSet = new Set( initiallyVisibleElements );

		unrevealedElements.forEach( function ( element ) {
			if ( initiallyVisibleSet.has( element ) ) {
				return;
			}

			observer.observe( element );
		} );

		if ( document.documentElement.dataset.nexoRevealPageEndBound !== 'true' ) {
			document.documentElement.dataset.nexoRevealPageEndBound = 'true';
			window.addEventListener( 'scroll', maybeRevealElementsAtPageEnd, { passive: true } );
			window.addEventListener( 'resize', maybeRevealElementsAtPageEnd );
		}

		void document.documentElement.offsetWidth;

		window.requestAnimationFrame( function () {
			window.setTimeout( function () {
				initiallyVisibleElements.forEach( function ( element ) {
					revealElement( element );
				} );
				maybeRevealElementsAtPageEnd();
			}, initialViewportRevealDelay );
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', function () {
			stampCf7Forms();
			initScienceVideos();
			initContactMaps();
			initScrollReveal();
		} );
	} else {
		stampCf7Forms();
		initScienceVideos();
		initContactMaps();
		initScrollReveal();
	}

	window.addEventListener( 'pageshow', function () {
		stampCf7Forms();
		initScienceVideos();
		initContactMaps();
		initScrollReveal();
	} );

	window.addEventListener( 'load', function () {
		initScienceVideos();
		initContactMaps();
		initScrollReveal();
	} );
} )();
